const defaultSa = {
  imperial: 15.875,
  metric: 10
};

export default defaultSa;
